(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-editorial"] && !Shopify.designMode) return;
  try {
    
// Sistema de animación por scroll para sección de texto - SCOPED
(function() {
  const currentScript = document.currentScript;
  const sectionElement = currentScript.closest('.text-editorial-section');
  
  if (!sectionElement) return;
  
  const sectionId = sectionElement.getAttribute('data-section-id');
  const isPreviewMode = sectionElement.hasAttribute('data-shopify-visual-preview');
  
  if (isPreviewMode) {
    sectionElement.classList.add('is-animated');
    const content = sectionElement.querySelector('.text-editorial-content');
    if (content) content.classList.add('is-animated');
    const items = sectionElement.querySelectorAll('.text-element-item');
    items.forEach(item => item.classList.add('is-animated'));
    return;
  }

  const observerConfig = {
    threshold: 0.1,
    rootMargin: '0px 0px -10% 0px'
  };

  const textObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.target === sectionElement) {
        entry.target.classList.add('scroll-animate');
        entry.target.classList.add('is-animated');
        
        const contentWrapper = entry.target.querySelector('.text-editorial-content');
        if (contentWrapper) {
          setTimeout(() => {
            contentWrapper.classList.add('is-animated');
          }, 100);
        }
        
        const textElements = entry.target.querySelectorAll('.text-element-item');
        textElements.forEach((element, index) => {
          setTimeout(() => {
            element.classList.add('is-animated');
          }, 150 + (index * 80));
        });
      }
    });
  }, observerConfig);

  const rect = sectionElement.getBoundingClientRect();
  if (rect.top < window.innerHeight && rect.bottom > 0) {
    sectionElement.classList.add('is-animated');
    const content = sectionElement.querySelector('.text-editorial-content');
    if (content) content.classList.add('is-animated');
    const items = sectionElement.querySelectorAll('.text-element-item');
    items.forEach(item => item.classList.add('is-animated'));
  } else {
    textObserver.observe(sectionElement);
  }

  let isScrolling = false;
  
  const handleScroll = () => {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        if (!sectionElement.classList.contains('is-animated')) {
          isScrolling = false;
          return;
        }
        
        const contentWrapper = sectionElement.querySelector('.text-editorial-content');
        if (contentWrapper) {
          const rect = contentWrapper.getBoundingClientRect();
          const viewportCenter = window.innerHeight / 2;
          const elementCenter = rect.top + (rect.height / 2);
          const distance = Math.abs(viewportCenter - elementCenter);
          const maxDistance = window.innerHeight;
          const opacity = Math.max(0.8, 1 - (distance / maxDistance) * 0.2);
          
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            contentWrapper.style.opacity = opacity;
          }
        }
        
        isScrolling = false;
      });
      
      isScrolling = true;
    }
  };
  
  window.addEventListener('scroll', handleScroll);
  
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail.sectionId === sectionId) {
        window.removeEventListener('scroll', handleScroll);
        textObserver.disconnect();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
